import React from 'react';

const PrintPlaceholder = () => {
  return (
    <div className="tooldialog__wrapper">
      <div className="tooldialog__wrapper-content">
        <ul className="generic-list placeholder__top-space">
          {Array.from({ length: 8 }, (_, i) => (
            <li key={`form-placeholder${i}`}>
              <div className="text__placeholder--big shimmer placeholder__bottom-space" />
            </li>
          ))}
        </ul>
        <div className="text__placeholder--small shimmer placeholder__bottom-space" />
        <div className="text__placeholder--big shimmer" />
      </div>
    </div>
  );
};

export default PrintPlaceholder;
